import dayjs from "dayjs";
import { DocData } from "../model/docData";

const DEADLINE_FORMAT = "HH:mm UTC+3 (Москва) DD.MM.YYYY";

/** Срок подписания истёк по дате из договора. */
export function isContractSigningPeriodExpired(doc: DocData): boolean {
    if (!doc.maxDate) {
        return false;
    }
    return dayjs(doc.maxDate).isBefore(dayjs());
}

export function getContractConcludeDeadlineText(doc: DocData): string {
    if (!doc.maxDate) {
        return "";
    }
    const deadline = dayjs(doc.maxDate);
    if (isContractSigningPeriodExpired(doc)) {
        return `Недоступно подписание после ${deadline.format(DEADLINE_FORMAT)}г.`;
    }
    return `Договор можно заключить до ${deadline.format(DEADLINE_FORMAT)}г.`;
}
